var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-2 bg-gray-50 rounded-full flex items-center"},[_c('SearchIcon',{staticClass:"mr-3 w-8 h-8 flex-shrink-0"}),_c('input',{staticClass:"bg-transparent w-full",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }